import React from 'react';

import {useParams} from 'react-router-dom';

import {Stack, Typography} from '@mui/material';

import PageContents from 'components/PageContents';
import CardDetailsBody from '../home/tabs/Cards/CardDetailsBody';

export default function CardPage() {
    const params = useParams();

    React.useEffect(() => {
        let cardId = params.cardId;
    }, []);

    if (!params.cardId) {
        return (
            <PageContents title='Card' current='card' type='data'>
                <Typography>Card id is missing</Typography>
            </PageContents>
        );
    }

    return (
        <PageContents title='Card' current='card' type='data'>
            <Stack direction='column' sx={{p: 4}}>
                <CardDetailsBody cardId={params.cardId} onChanged={() => {}}/>
            </Stack>
        </PageContents>
    );
}

